import { I18n } from '@calendly/i18n';
import classNames from 'classnames';
import { forwardRef } from 'react';
import crown from './crown.svg';
const iconCss = "idz71xw";
const Icon = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'img';
  return <Component ref={ref} {...restProps} className={classNames(iconCss, props.className)} />;
});
const containerHasBackgroundCss = "c8luh8y";
const containerCss = "c1mpcbtc";
const Container = forwardRef((props, ref) => {
  const {
    hasBackground,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, {
    [containerHasBackgroundCss]: hasBackground
  }, props.className)} />;
});
const StrongWrapper = ({
  children,
  needToWrap
}) => needToWrap ? <strong>{children}</strong> : children;
export const ManagingBadge = ({
  background = true,
  strong = false,
  userGroupManaged = false
}) => {
  const translatedString = userGroupManaged ? I18n.t('publisher.organization.managed_event_types.group_managed_badge') : I18n.t('publisher.organization.managed_event_types.admin_managed_badge');
  return <Container hasBackground={background}>
      <Icon src={crown} alt="" />
      <StrongWrapper needToWrap={strong}>
        {translatedString}
      </StrongWrapper>
    </Container>;
};

require("./managing_badge.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./managing_badge.js");